export const EVENT_CHAT_CREATED = 'chat_created'
export const EVENT_CHAT_SHARED = 'chat_shared'
export const EVENT_INTERNET_IMAGE_SEARCH = 'internet_image_search'
